
// react-routers components
import { Link } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Images
import { Warning } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import MDCard from "components/MDCard";
function InfoCard({ title, description }) {
  const { t } = useTranslation();

  return (
    <MDCard>
      <MDTypography>{title}</MDTypography>
      <Grid container spacing={2} alignItems="center">
        <Grid item lg={8}>
          <TextField fullWidth value="test@gmail.com" id="fullWidth" sx={{ my: 1 }} />
        </Grid>
        <Grid item>
          <MDTypography lg={4}> : ArshId &nbsp;</MDTypography>
        </Grid>
      </Grid>
      <MDTypography component="p" color="text" fontSize="sm">
        {description}
      </MDTypography>
      <Divider />
      <MDBox display="flex">
        <Warning color="warning" />
        <MDTypography fontWeight="regular" color="text" fontSize="xs">
          &nbsp;خودت هم میتونی به غیر از شرکت برای خودت arshId بسازی و از خدمات ما بهره ببری
        </MDTypography>
      </MDBox>
    </MDCard>
  );
}

// Setting default props for the InfoCard
InfoCard.defaultProps = {
  shadow: true,
};

// Typechecking props for the InfoCard
InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  info: PropTypes.objectOf(PropTypes.string).isRequired,
  social: PropTypes.arrayOf(PropTypes.object).isRequired,
  action: PropTypes.shape({
    route: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
  }).isRequired,
  shadow: PropTypes.bool,
};

export default InfoCard;
